import fetch from '.';

/**
 * Get the the subject by using a string lookup in the api
 */
export const getSubjectsByStringApi = (
	benchmarkId: number,
	subjectString: string,
	academicYear?: number
): Promise<ResponseBuilder<SubjectBedrock>> => {
	return fetch('/bedrock/v1/Subjects/Subjects/GetSubjectByString', {
		method: 'POST',
		body: {
			BenchmarkId: benchmarkId,
			SubjectId: null,
			SubjectString: subjectString,
			Reportlevel: null,
			AcademicYear: academicYear,
			UseDisplayNameOnFallback: false,
		},
	});
};

/**
 * Get the subjects by supplying a list of subject ids
 */
export const getSubjectsByIdApi = (
	subjectIds: number[]
): Promise<ResponseBuilder<Array<SubjectBedrock>>> => {
	return fetch('/bedrock/v1/Subjects/Subjects/GetSubjectsById', {
		method: 'POST',
		body: {
			SubjectIds: subjectIds,
		},
	});
};

/**
 * Get the full subject info by supplying a list of subject names
 * @param subjectNames The subject names to get the info for
 * @param benchmarkId The benchmark id to get the info for
 * @param academicYear The academic year to get the info for
 * @param fallbackToAllYears Whether to fallback to all years if the subject is not found for the given academic year
 * @returns A promise that resolves to an array of SubjectBedrock objects
 */
export const getSubjectsByNameApi = (
	subjectNames: string[],
	benchmarkId: number,
	academicYear?: number,
	fallbackToAllYears?: boolean
): Promise<ResponseBuilder<Array<SubjectBedrock>>> => {
	return fetch('/bedrock/v1/Subjects/Subjects/GetSubjectsByName', {
		method: 'POST',
		body: {
			SubjectNames: subjectNames,
			BenchmarkId: benchmarkId,
			AcademicYear: academicYear,
			FallbackToAllYears: fallbackToAllYears,
		},
	});
};

/**
 * Get the comparison for a givene type i.e. gender, ethnicity, etc
 */
export const getFieldComparisonsByApi = (
	benchmarkId: number,
	field: string
): Promise<ResponseBuilder<Array<ComparisonBedrock>>> => {
	return fetch('/bedrock/v1/Comparisons/Comparisons/GetFieldComparisons', {
		method: 'POST',
		body: {
			BenchmarkId: benchmarkId,
			ComparisonName: field,
		},
	});
};
